var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"4edba5d13b4668e21abe1a6b0bf090c71b03a8e5"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["tours@smartrent"]={id:"4edba5d13b4668e21abe1a6b0bf090c71b03a8e5"};
      